module.exports = __webpack_public_path__ + "static/media/printer.4039b4c0.svg";